//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { SwipeCell, Cell, CellGroup } from "vant";
import { PowerScanner } from "@/0/Utils/PowerScanner";
import WxjsSdk from "@/Manager/10.Tms/ProductSnManager";
import "@/assets/css/reset.css";
import "@/assets/css/global.css";
export default {
  name: "",
  components: {
    [SwipeCell.name]: SwipeCell,
    // [CellGroup.name]: CellGroup,
    [Cell.name]: Cell
  },
  props: ["config"],

  data() {
    return {
      powerScanner: null
    };
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  async created() {
    this.wxJsSdk();
    //this.powerScanner.scan("http://ysl.entfly.com/mYslPms/ProductSn?sn=00471750300018069012");
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  async mounted() {
    this.wxJsSdk();
    console.log("mounted.....");
    this.powerScanner = new PowerScanner();
    var stockConfig = this.getConfig();
    this.powerScanner.setConfig(stockConfig);
    await this.powerScanner.init();
    await this.powerScanner.checkSync();
  },

  methods: {
    getConfig() {
      switch (this.config.StockOrderType) {
        case 0: {
          let stockConfig = {
            InitUrl: "mSmsApi/ShopStockInOrder/Init",
            ClearUrl: "mSmsApi/ShopStockInOrder/Clear",
            ClearFailedScanCodeListUrl:
              "mSmsApi/ShopStockInOrder/ClearFailedScanCodeList",
            DeleteFailedScanCodeListUrl:
              "mSmsApi/ShopStockInOrder/DeleteFailedScanCodeList",
            DeleteScanCodeListUrl:
              "mSmsApi/ShopStockInOrder/DeleteScanCodeList",
            SubmitUrl: "mSmsApi/ShopStockInOrder/Submit",
            ScanCodeUrl: "mSmsApi/ShopStockInOrder/ScanCode2"
          };
          return stockConfig;
        }
        case 1: {
          let stockConfig = {
            InitUrl: "mSmsApi/ShopStockOutOrder/Init",
            ClearUrl: "mSmsApi/ShopStockOutOrder/Clear",
            ClearFailedScanCodeListUrl:
              "mSmsApi/ShopStockOutOrder/ClearFailedScanCodeList",
            DeleteFailedScanCodeListUrl:
              "mSmsApi/ShopStockOutOrder/DeleteFailedScanCodeList",
            DeleteScanCodeListUrl:
              "mSmsApi/ShopStockOutOrder/DeleteScanCodeList",
            SubmitUrl: "mSmsApi/ShopStockOutOrder/Submit",
            ScanCodeUrl: "mSmsApi/ShopStockOutOrder/ScanCode2"
          };
          return stockConfig;
        }
        case 2: {
          let stockConfig = {
            InitUrl: "mSmsApi/ShopStockCheckOrder/Init",
            ClearUrl: "mSmsApi/ShopStockCheckOrder/Clear",
            ClearFailedScanCodeListUrl:
              "mSmsApi/ShopStockCheckOrder/ClearFailedScanCodeList",
            DeleteFailedScanCodeListUrl:
              "mSmsApi/ShopStockCheckOrder/DeleteFailedScanCodeList",
            DeleteScanCodeListUrl:
              "mSmsApi/ShopStockCheckOrder/DeleteScanCodeList",
            SubmitUrl: "mSmsApi/ShopStockCheckOrder/Submit",
            ScanCodeUrl: "mSmsApi/ShopStockCheckOrder/ScanCode2"
          };
          return stockConfig;
        }
      }
      return null;
    },
    ClearFailedScanCode() {
      console.log(this.powerScanner, "?mmm");
      this.powerScanner.clearFailedScanCode();
    },
    openScan() {
      if (!this.powerScanner) return;
      this.powerScanner.openScan();
    },
    alertObj(obj) {
      var output = "";
      for (var i in obj) {
        var property = obj[i];
        output += i + " = " + property + "\n";
      }
      alert(output);
    },
    async submitOrder(endUrl) {
      this.$msg.confirm("您是否确定要提交？", async () => {
        // this.$router.push({ path: "/Sms/ShopStockInBuyOrder/End" });
        this.$msg.showLoading("正在提交...");
        var result = await this.powerScanner.submit();
        this.$msg.hideLoading();

        if (result.state == 1) {
          this.$msg.succ(result.msg);
          if (endUrl) {
            endUrl += "?openId=" + result.data.OpenId;
            this.$path.to(endUrl);
            //this.$router.push({ path: endUrl });
          }
          return;
        }
        this.$msg.alert(result.msg);
      });
    },
    refreshUI() {
      this.powerScanner.refreshUI();
    },

    refreshData() {
      this.powerScanner.refreshData();
    },

    onRefreshClick(powerScanner) {
      console.log("onRefreshClick", powerScanner);
      if (!powerScanner) return;
      powerScanner.refreshData();
    },

    onClearClick(powerScanner) {
      console.log("onClearClick", powerScanner);
      if (!powerScanner) return;
      powerScanner.clearData();
    },
    delMethod(scanCode) {
      console.log(scanCode.Code, "删除");
      this.powerScanner.deleteScanCode(scanCode.Code);
    },
    DelCode(scanCode) {
      console.log(scanCode.Code, "删除");
      this.powerScanner.deleteFailedScanCode(scanCode.Code);
    },
    wxJsSdk() {
      var wxUrl = window.location.href.split("#")[0];
      var sdkData = {
        uOpenId: "8659662804444e4b9ff929bb78b3da21",
        url: wxUrl
      };
      WxjsSdk.wxJsSdk(sdkData).then(res => {
        // this.$msg.hideLoading();
        wx.config({
          debug: false, // true,// 开启调试模式
          appId: res.appId, // 必填，公众号的唯一标识
          timestamp: res.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.nonceStr, // 必填，生成签名的随机串
          signature: res.signature, // 必填，签名，见附录1
          // 必填，需要使用的JS接口列表
          jsApiList: ["scanQRCode"]
        });
      });
    }
  }
};
